import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useConfig, useOptions } from '../../../../selectors';
import { SmallSelectables } from '../../common/selectable/containers/SmallSelectabes';
import { SelectableLogo } from '../../common/selectable/logo/SelectableLogo';
import { updateOptions } from '../../../../actions';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { getPublicId, toggleAndKeepOne } from '../../../../utils';

export const Overlays: FC = () => {
  const analytics = useAnalytics();
  const dispatch = useDispatch();
  const config = useConfig();
  const { selectedThemeIndex, unselectedOverlayIndexes } = useOptions();
  const selectedTheme = config.themes[selectedThemeIndex];

  const handleOverlayClick = useCallback((index: number, overlayPublicId: string) => {
    const newState = !unselectedOverlayIndexes[index];
    analytics('edit image overlay', `${newState ? 'enable' : 'disable'} ${overlayPublicId} image overlay`);

    const defaultState = {
      ...selectedTheme?.overlays.map(() => false),
      ...unselectedOverlayIndexes
    } as unknown as Record<string, boolean>;

    dispatch(updateOptions({
      unselectedOverlayIndexes: toggleAndKeepOne(defaultState, index, false),
    }));
  }, [analytics, dispatch, selectedTheme, unselectedOverlayIndexes]);

  return (
    <div>
      <SmallSelectables data-test="overlays-container">
        {selectedTheme?.overlays.map((overlayName, index) => {
          const overlayPublicId = getPublicId('overlay', config, selectedThemeIndex, overlayName);
          return (
            <SmallSelectables.Item key={overlayPublicId}>
              <SelectableLogo
                isSelected={!unselectedOverlayIndexes[index]}
                onClick={() => handleOverlayClick(index, overlayPublicId)}
                publicId={overlayPublicId}
                data-test={`overlay-${index}`}
              />
            </SmallSelectables.Item>
          );
        })}
      </SmallSelectables>
    </div>
  );
};
